import React from "react";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box } from "@mui/material";

const Avatar = () => {
  const { usuario } = useSelector((state) => state.user);

  return (
    <Box>
      <Button
        style={{ marginLeft: "10px", color: "white", position: "absolute" }}
      >
        <AccountCircleIcon style={{ marginRight: "20px", color: "white" }} />{" "}
        {usuario}
      </Button>
    </Box>
  );
};

export default Avatar;
